import { toast } from 'react-toastify';

export default function notification(msg, config) {
  const message = msg;
  const { type, translate, ...restConfig } = config;
  return toast[config.type](message, restConfig);
}

export const toastIds = {
  atualizacaoDETRAN: 'atualizacaoDETRAN',
  validacaoVeiculoComplementar: 'validacaoVeiculoComplementar',
};

export const closeToast = (toastId) => {
  notification(null, {id: toastId, type: 'dismiss'});
}